import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { AlertTriangle } from 'react-feather';

class SetSecurityQuestionsModal extends Component {
    render() {
        return (<div>
            <div className="modal-header">
                <h6 className="modal-title">Set Security Questions</h6>
                {/* //Bunny Requested to make the security questions required.
                //also set the close handler in Announcments.js to force it to stay open --TA */}
                {/* <button type="button" className="close" onClick={this.props.modalClosed}>
                    <span aria-hidden="true">x</span>
                </button> */}
            </div>
            <div className="modal-body">
                <div>
                    <div className="text-center mb-3"><AlertTriangle color="red" size={25} /></div>
                    <p style={{ fontSize: "14px" }}>You have not yet set your security questions. You can do this in Settings by clicking the button below. Setting your security questions will help keep your account secure and assist in account recovery if needed.</p>
                </div>

                <div className="text-center">
                    <Link to='/settings' className="btn btn-sm btn-info">Go to Settings</Link>
                </div>
            </div>
        </div>);
    }
}

export default SetSecurityQuestionsModal;